export default __webpack_public_path__ + "static/media/mosaic1.6a908d1a.png";